import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import cookie from 'cookie';
import getEnvs from '@clearscore-group/lib.helpers.envs';
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
var hasDocumentCookie = function hasDocumentCookie() {
  return canUseDom() && 'cookie' in window.document;
};

// if it looks like JSON, we'll treat it like JSON
var isParsingCookie = function isParsingCookie() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value[0] === '{' || value[0] === '[' || value[0] === '"';
};
var readCookie = function readCookie(value) {
  if (isParsingCookie(value)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // at least we tried
    }
  }
  return value;
};
var getDefaultOptions = function getDefaultOptions() {
  return _objectSpread(_objectSpread({}, getEnvs('COOKIE_DOMAIN') && {
    domain: getEnvs('COOKIE_DOMAIN')
  }), {}, {
    path: '/',
    secure: true
  });
};

/**
 * set cookie
 * @param {string} cookieName
 * @param {any} payload
 * @param {object} options
 */
var setCookie$1 = function setCookie$1(cookieName, payload, options) {
  var cookieValue = typeof payload === 'object' ? JSON.stringify(payload) : payload;
  if (hasDocumentCookie()) {
    document.cookie = cookie.serialize(cookieName, cookieValue, _objectSpread(_objectSpread({}, getDefaultOptions()), options));
  }
};

/**
 * get cookie
 * @param {string} cookieName
 */
var getCookie$1 = function getCookie$1(cookieName) {
  if (hasDocumentCookie()) {
    var _document$cookie;
    var cookieValue = cookie.parse((_document$cookie = document.cookie) !== null && _document$cookie !== void 0 ? _document$cookie : '')[cookieName];
    return readCookie(cookieValue);
  }
  return null;
};

/**
 * get all cookies
 */
var getAllCookies$1 = function getAllCookies$1() {
  if (hasDocumentCookie()) {
    var _document$cookie2;
    var allCookies = cookie.parse((_document$cookie2 = document.cookie) !== null && _document$cookie2 !== void 0 ? _document$cookie2 : '');
    return Object.entries(allCookies).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        cookieKey = _ref2[0],
        cookieValue = _ref2[1];
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cookieKey, readCookie(cookieValue)));
    }, {});
  }
  return null;
};

/**
 * deletes cookie
 * @param {string} cookieName
 */
var removeCookie$1 = function removeCookie$1(cookieName) {
  if (hasDocumentCookie()) {
    var options = _objectSpread(_objectSpread({}, getDefaultOptions()), {}, {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    document.cookie = cookie.serialize(cookieName, '', options);
  }
};
var CS_SESSION_COOKIE = getEnvs('SESSION_COOKIE') || 'CS_SESSION';
var CS_PERSON_COOKIE = 'CS_PERSON';
var CS_PUBLISHER_ID = 'CS_PUBLISHER_ID';
var VISITED_SITE_COOKIE_NAME = 'CS_VISITED_SITE';
// Please note this is concatenated with `alertId` to give full cookie key
var CS_ALERT_VIEWED_COOKIE_PREFIX = 'CS_ALERT_VIEWED';
var CS_CURRENT_LANGUAGE = 'CS_CURRENT_LANGUAGE';

// Expiry (in milliseconds)
var EXPIRE_3DAYS = 259200000;
var consts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CS_SESSION_COOKIE: CS_SESSION_COOKIE,
  CS_PERSON_COOKIE: CS_PERSON_COOKIE,
  CS_PUBLISHER_ID: CS_PUBLISHER_ID,
  VISITED_SITE_COOKIE_NAME: VISITED_SITE_COOKIE_NAME,
  CS_ALERT_VIEWED_COOKIE_PREFIX: CS_ALERT_VIEWED_COOKIE_PREFIX,
  CS_CURRENT_LANGUAGE: CS_CURRENT_LANGUAGE,
  EXPIRE_3DAYS: EXPIRE_3DAYS
});

/**
 * Directly set the publisher cookie to `body` with no validation
 */
var setPublisherCookieValue = function setPublisherCookieValue(body) {
  return setCookie$1(CS_PUBLISHER_ID, body, {
    expires: new Date(Date.now() + EXPIRE_3DAYS)
  });
};

/**
 * Sets the CS_PUBLISHER_ID cookie if utm_source + utm_medium is present in search params
 * @param {String} searchParams
 */
var setPublisherCookie$1 = function setPublisherCookie$1() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var urlParams = new URLSearchParams(searchParams);
  var publisherId = urlParams.get('utm_source');
  var transactionId = urlParams.get('utm_medium');
  var campaignId = urlParams.get('utm_campaign');
  if (publisherId && transactionId) {
    setPublisherCookieValue(_objectSpread({
      publisherId: publisherId,
      transactionId: transactionId
    }, campaignId && {
      campaignId: campaignId
    }));
  }
};

/**
 * Returns CS_PUBLISHER_ID cookie or {} if it does not exist
 */
var getPublisherCookie$1 = function getPublisherCookie$1() {
  return getCookie$1(CS_PUBLISHER_ID) || {};
};

/**
 * Returns CS_PUBLISHER_ID cookie (if present) as the original map
 * of `utm_xxx` to value as opposed to the mappings above (`publisherId` etc.)
 */
var getPublisherCookieUTM$1 = function getPublisherCookieUTM$1() {
  var _getPublisherCookie$ = getPublisherCookie$1(),
    publisherId = _getPublisherCookie$.publisherId,
    transactionId = _getPublisherCookie$.transactionId,
    campaignId = _getPublisherCookie$.campaignId,
    sentToBackend = _getPublisherCookie$.sentToBackend;
  if (!publisherId || !transactionId) {
    return {};
  }
  return _objectSpread(_objectSpread({
    utm_source: publisherId,
    utm_medium: transactionId
  }, campaignId && {
    utm_campaign: campaignId
  }), sentToBackend && {
    sentToBackend: sentToBackend
  });
};

/**
 * Check if a given publisher cookie has been sent to the backend
 * @param {Object} publisherCookie Publisher cookie as returned from `getPublisherCookie`
 */
var publisherCookieIsSentToBackend$1 = function publisherCookieIsSentToBackend$1(publisherCookie) {
  return !!publisherCookie.sentToBackend;
};

/**
 * Mark the publisher cookie as "sent to the backend" so we can avoid sending it again
 */
var markPublisherCookieAsSentToBackend$1 = function markPublisherCookieAsSentToBackend$1() {
  var pubCookie = getPublisherCookie$1();
  if (Object.entries(pubCookie).length > 0 && !publisherCookieIsSentToBackend$1(pubCookie)) {
    setPublisherCookieValue(_objectSpread(_objectSpread({}, pubCookie), {}, {
      sentToBackend: true
    }));
  }
};
var second$1 = 1000;
var minute$1 = second$1 * 60;
var thirtyMinutes = minute$1 * 30;
var setPersonCookie$1 = function setPersonCookie$1(personIdentifier) {
  setCookie$1(CS_PERSON_COOKIE, personIdentifier, {
    expires: new Date(new Date().getTime() + thirtyMinutes)
  });
};
var getPersonCookie$1 = function getPersonCookie$1() {
  return getCookie$1(CS_PERSON_COOKIE);
};
var removePersonCookie$1 = function removePersonCookie$1() {
  return removeCookie$1(CS_PERSON_COOKIE);
};
var second = 1000;
var minute = second * 60;
var hour = minute * 60;
var day = hour * 24;
var oneYear = day * 365;
var setVisitedSiteCookie$1 = function setVisitedSiteCookie$1(userIdentifier) {
  setCookie$1(VISITED_SITE_COOKIE_NAME, userIdentifier, {
    expires: new Date(new Date().getTime() + oneYear)
  });
};
var getVisitedSiteCookie$1 = function getVisitedSiteCookie$1() {
  return getCookie$1(VISITED_SITE_COOKIE_NAME);
};
var removeVisitedSiteCookie$1 = function removeVisitedSiteCookie$1() {
  return removeCookie$1(VISITED_SITE_COOKIE_NAME);
};

// needed for the remember-me checkbox on login
// work around since you can not use JS APIs to calculate if a cookie has 'expires' set
// We create a session with 'expires', then when changing language, or refreshing a token, we update the cookie.
// except, 'updating' cookies is impossible, so we need to cache the unreachable properties of the cookie
var CS_SESSION_EXPIRES = 'CS_SESSION_EXPIRES';
var setExpires = function setExpires(expiresDate) {
  window[CS_SESSION_EXPIRES] = expiresDate;
};
var getExpires = function getExpires() {
  return window[CS_SESSION_EXPIRES];
};

/**
 * Sets the session cookie
 * @param session.sessionToken
 * @param session.accountId
 * @param session.username
 * @param session.market
 * @todo SESSION - remove old auth flow when LLT/2FA is live
 */
var setSessionCookie$1 = function setSessionCookie$1(_ref3) {
  var market = _ref3.market,
    access_token = _ref3.access_token,
    refresh_token = _ref3.refresh_token,
    session_id = _ref3.session_id,
    remember = _ref3.remember,
    o_token = _ref3.o_token,
    locale = _ref3.locale;
  var expiresDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  setExpires(remember ? expiresDate : undefined);
  setCookie$1(CS_SESSION_COOKIE, _objectSpread({
    access_token: access_token,
    refresh_token: refresh_token,
    session_id: session_id,
    o_token: o_token,
    market: market.toLowerCase()
  }, locale ? {
    locale: locale
  } : {}), _objectSpread({}, remember && {
    expires: getExpires()
  }));
};
/* eslint-enable camelcase */

/**
 * Update the session cookie
 */
var updateSessionCookie$1 = function updateSessionCookie$1(data) {
  var cookie = getCookie$1(CS_SESSION_COOKIE);
  setSessionCookie$1(_objectSpread(_objectSpread(_objectSpread({}, cookie), data), {}, {
    remember: !!getExpires()
  }));
};

/**
 * Get the session cookie
 */
var getSessionCookie$1 = function getSessionCookie$1() {
  return getCookie$1(CS_SESSION_COOKIE);
};

/**
 * Removes the session cookie
 */
var removeSessionCookie$1 = function removeSessionCookie$1() {
  removeCookie$1(CS_SESSION_COOKIE);
};
var getKeyForAlertId = function getKeyForAlertId(alertId) {
  return "".concat(CS_ALERT_VIEWED_COOKIE_PREFIX, "_").concat(alertId.toUpperCase());
};
var setAlertCookie$1 = function setAlertCookie$1(alertId, alertCooldown) {
  var key = getKeyForAlertId(alertId);
  setCookie$1(key, true, {
    expires: new Date(Date.now() + alertCooldown)
  });
};
var getAlertCookie$1 = function getAlertCookie$1(alertId) {
  return getCookie$1(getKeyForAlertId(alertId)) || null;
};
var hasCookieForAlert$1 = function hasCookieForAlert$1(alertId) {
  return getAlertCookie$1(alertId) !== null;
};
var getAllCookies = getAllCookies$1;
var setCookie = setCookie$1;
var getCookie = getCookie$1;
var removeCookie = removeCookie$1;
var getPersonCookie = getPersonCookie$1;
var setPersonCookie = setPersonCookie$1;
var removePersonCookie = removePersonCookie$1;
var getVisitedSiteCookie = getVisitedSiteCookie$1;
var setVisitedSiteCookie = setVisitedSiteCookie$1;
var removeVisitedSiteCookie = removeVisitedSiteCookie$1;
var getPublisherCookie = getPublisherCookie$1;
var setPublisherCookie = setPublisherCookie$1;
var getPublisherCookieUTM = getPublisherCookieUTM$1;
var publisherCookieIsSentToBackend = publisherCookieIsSentToBackend$1;
var markPublisherCookieAsSentToBackend = markPublisherCookieAsSentToBackend$1;
var setSessionCookie = setSessionCookie$1;
var getSessionCookie = getSessionCookie$1;
var updateSessionCookie = updateSessionCookie$1;
var removeSessionCookie = removeSessionCookie$1;
var getAlertCookie = getAlertCookie$1;
var setAlertCookie = setAlertCookie$1;
var hasCookieForAlert = hasCookieForAlert$1;
var constants = consts;
export { constants, getAlertCookie, getAllCookies, getCookie, getPersonCookie, getPublisherCookie, getPublisherCookieUTM, getSessionCookie, getVisitedSiteCookie, hasCookieForAlert, markPublisherCookieAsSentToBackend, publisherCookieIsSentToBackend, removeCookie, removePersonCookie, removeSessionCookie, removeVisitedSiteCookie, setAlertCookie, setCookie, setPersonCookie, setPublisherCookie, setSessionCookie, setVisitedSiteCookie, updateSessionCookie };